import { render } from "./ButtonMenu.vue?vue&type=template&id=afd91e96"
import script from "./ButtonMenu.vue?vue&type=script&lang=js"
export * from "./ButtonMenu.vue?vue&type=script&lang=js"
script.render = render

export default script